import WorkingHoursTable from './Table';
import styles from './index.module.scss';

type WorkingHoursProps = {
	selectedPayrollId: string;
	onlyView: boolean;
	headerData: any;
	setIsUniversalLoading: any;
	showSteps:boolean
};
const WorkHourComponent = (props: WorkingHoursProps) => {
	const {
		selectedPayrollId,
		onlyView,
		headerData,
		setIsUniversalLoading,
		showSteps,
	} = props;

	return (
		<div className={styles['work-hours__table']}>
			<WorkingHoursTable
				selectedPayrollId={selectedPayrollId}
				onlyView={onlyView}
				setIsUniversalLoading={setIsUniversalLoading}
				headerData={headerData}
				showSteps={showSteps}
			/>
		</div>
	);
};

export default WorkHourComponent;	
